function SearchParentsFor(start, cls, top) {
    var result;

    var parent = start.parentNode;
    if ((parent) && (parent.getAttribute)) {
        var pcls = parent.getAttribute("class");
        if (pcls) {
            var pclsArray = pcls.split(" ");
            for (var i = 0; i < pclsArray.length; i++) {
                if (pclsArray[i] == cls) {
                    result = parent;
                    break;
                }
            }
        }

        if ((!result) && ((!top) || (parent != top))) {
            result = SearchParentsFor(parent, cls, top);
        }
    }

    return (result);
}

function listenSlideNavigationButton() 
{
    var navigationButtons = document.querySelectorAll( '.navigationButton' );
    navigationButtons.forEach( function( navigationButton )
    {
        navigationButton.addEventListener( 'click' , () => 
        {  
            var weight = document.getElementById( "weight" ).value;
            var error = document.querySelector( ".error-message" );
            var selected_activity = document.querySelector( "input[ name='active_animal' ]:checked" );
            
            if( weight == "" )
            {
                error.style.display = "block";
                return false;
            }
            else if ( selected_activity == null ) 
            {
                var activity_wrapper = document.querySelector( ".active_pet" );
                var error_message = activity_wrapper.querySelector( '.error-message' );
                error_message.style.display="block";
                return false;
            }
            else
            {

                var all_calculator_boxes =  document.querySelectorAll( '.calculator_box' );
                all_calculator_boxes.forEach( function( calculator_box )
                {
                    calculator_box.classList.remove( 'active' );
                });
                var parent = SearchParentsFor(navigationButton, "pet_food_calculation");
                var go_to_slide = parent.querySelector( '.' + navigationButton.dataset.go_to);
                go_to_slide.classList.add( 'active' )
            }
        });

    });


    var weight_box = document.getElementById( "weight" );
    weight_box.addEventListener( 'change' , () => 
    {
        var weight_parent = SearchParentsFor( weight_box, "weight_content_wraper" );
        var error_message = weight_parent.querySelector( '.error-message' );
        error_message.style.display = "none";
    });
    
}

function listenRadioChange( calulator_option ) 
{
    calulator_option.addEventListener( 'change' , () => 
    {   
        var all_pet_block_options =  document.querySelectorAll( '.pet_block_option' );
        
        all_pet_block_options.forEach( function( all_pet_block_option )
        {
            all_pet_block_option.classList.remove( 'active' );
        });
        var pet_block_option = SearchParentsFor( calulator_option, "pet_block_option" );
        pet_block_option.classList.add( 'active' );
        
        var activity_parent = SearchParentsFor(calulator_option, "active_pet");
        var error_message = activity_parent.querySelector('.error-message');
        error_message.style.display="none";
    })
    
}

function listenSubscriptionButton() 
{
    var subscription_boxes = document.querySelectorAll( '.subscription_box input[name="selling_plan"]' );
    subscription_boxes.forEach( function( subscription_box )
    {
        subscription_box.addEventListener( 'change' , () => 
        {  
            var all_subscription_box_options =  document.querySelectorAll( '.subscription_box_option' );
            all_subscription_box_options.forEach( function( all_subscription_box_option )
            {
                all_subscription_box_option.classList.remove( 'option--active' );
            });

            var parent = SearchParentsFor( subscription_box, "subscription_box_option" );
            parent.classList.add( 'option--active' );

            if (  parent.getAttribute( "data-sub-id" ) == 'onetime_option') 
            {
                var weekSelectBox = document.querySelector( '.selling_plan_all_groups' );
                var error_message = document.querySelector( '.error_message' );  
                if ( error_message ) 
                {                    
                    weekSelectBox.classList.remove("error");
                    error_message.remove();
                }              
            }
        });
    });
}


function calculateAmt()
{
    var weight = $('input[name="weight"]').val();
    var category = $('input[name="foodCategory"]').val();
    var isTreats = getTreats();
    var activityLevel =$('input[name="active_animal"]:checked').val();
    var calDensity = $('input[name="flavourCalories"]').val();

    $('input[name="grams"]').val(parseInt(Math.round(ReallyRunFeedingCalulation(weight,category,isTreats,activityLevel,calDensity)* 10) / 10) ) ;
   
}



function calculateMix()
{
    var type          = $('input[name="foodType"]').val();
    var weight        = $('input[name="weight"]').val();
    var category      = $('input[name="foodCategory"]').val();
    var activityLevel = $('input[name="active_animal"]:checked').val();
    var wetDensity    = Number( $('input[name="flavourCalories"]').val( ) );
    var defaultCal,dryAmt,wetAmt,RER;

    var isTreats     = getTreats();
    var calories     = ReallyRunFeedingCalulation( weight, category, isTreats, activityLevel, 1 );
    var rows         = document.querySelectorAll(".food_table tbody tr");
    var calorieTexts = document.querySelectorAll(".calories");
    var dryDensity   = Number( $('input[name="deafultDry"]').val( ) );

    for ( var x = 0; x < calorieTexts.length; x++ )
    {
        calorieTexts[ x ].innerText = Math.round( ( calories * 10 ) / 10 );
    }

    for ( var i = 0; i < rows.length; i++ )
    {
        var row      = rows[ i ];
        var cells    = row.querySelectorAll( "td" );
        var ratio    = row.getAttribute( "ratio" ).split( "/" );
        var wetAmt   = parseInt( ratio[ 0 ] ) / 100;
        var dryAmt   = parseInt( ratio[ 1 ] ) / 100;

        if ( dryAmt > 0 )
        {
            var ratio    = wetAmt / dryAmt;
            var wetGrams = calories / ( dryDensity + ( wetDensity * ratio ) );
            var dryGrams = wetGrams * ratio;

            cells[ 1 ].textContent = Math.round( wetGrams );
            cells[ 2 ].textContent = Math.round( dryGrams );
        }
        else
        {
            var wetGrams = calories / wetDensity;
            cells[ 2 ].textContent = Math.round( wetGrams );
            cells[ 1 ].textContent = 0;
        }
    }

    //if(type == "dry")
    //{
    //    dryAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,calDensity);
    //    console.log("Dry = " + dryAmt);
    //    // defaultCal = $('input[name="deafultWet"]').val();
    //    defaultCal = calDensity;
    //    wetAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,defaultCal);
    //    console.log("Wet = " + dryAmt);
    //
    //    
    //
    //    RER = dryAmt * calDensity;
    //    assignRatios(RER,wetAmt,dryAmt);
    //}
    //else if(type == "wet")
    //{
    //    wetAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,calDensity);
    //    // defaultCal = $('input[name="deafultDry"]').val();
    //    defaultCal = calDensity;
    //    dryAmt = ReallyRunFeedingCalulation(weight,category,false,activityLevel,defaultCal);
    //    
    //    RER = wetAmt * calDensity;
    //    assignRatios(RER,wetAmt,dryAmt);
    //}

}

function assignRatios(RER,wetGrams,dryGrams)
{
    var rows = document.querySelectorAll(".food_table tbody tr")

    var calorieTexts = document.querySelectorAll(".calories")

    for(var x = 0; x < calorieTexts.length; x++)
    {
        calorieTexts[0].innerText = Math.round((RER * 10) / 10)
        
    }

    
    for(var i = 0; i < rows.length; i++)
    {
        var row = rows[i];
        var cells = row.querySelectorAll("td");
        var ratio = row.getAttribute("ratio").split("/");
        var wetAmt = parseInt(ratio[0])/100;
        var dryAmt = parseInt(ratio[1])/100;

        cells[1].textContent = Math.round((wetGrams*wetAmt * 10) / 10)
        cells[2].textContent = Math.round((dryGrams*dryAmt * 10) / 10)

    }
}

function ReallyRunFeedingCalulation(weight,category,isTreats,activityLevel,calDensity)
{   
    var grams;


    if(category == "cat")
    {
        if(isTreats == false)
        {
            grams = calorieCalculation(category,weight,0.711,activityLevel,calDensity,false);
        }
        else if( isTreats )
        {
            grams = calorieCalculation(category,weight,0.711,activityLevel,calDensity,false)*0.9;
        }
    }
    else if(category == "kitten")
    {        
        grams = calorieCalculation(category,weight,0.67,activityLevel,calDensity,true)/0.9;
    }
    else if(category == "dog")
    {

        if(isTreats == false)
        {
            grams = calorieCalculation(category,weight,0.75,activityLevel,calDensity,false);

        }
        else if( isTreats )
        {
            grams = calorieCalculation(category,weight,0.75,activityLevel,calDensity,false)*0.9;
        }
    }
    else if (category == "puppy")
    {
   
        grams = calorieCalculation(category,weight,0.75,activityLevel,calDensity,false)/0.9;

    }

    grams = Math.round(grams);

    return grams;
}

function getTreats()
{
    var seniorCheckbox = $('input[name="treats"]:checked')

    if(seniorCheckbox[0])
    {
        return true;
    }
    else
    {
        return false;
    }
}

function calorieCalculation(category, weight, rerMultiplier, activityLevel, calDensity)
{
    console.log( weight,rerMultiplier,activityLevel,calDensity );
    var age = parseFloat($('select[name="age"]').find(":selected").val());
    var ageText = $('select[name="age"]').find(":selected").attr("data-age");
    if( ageText.includes("months") )
    {
        ageText = ageText.split(" ")[0];
        ageMin = ageText.split("-")[0];
        ageMax = ageText.split("-")[1];
        if( category == "cat" )
        {
            var ageLimit = $('.product_feeding_calculator_section').attr('data-kitten-age');
        }
        else if( category == "dog" )
        {
            var ageLimit = $('.product_feeding_calculator_section').attr('data-puppy-age');
        }
        if( ageLimit <= ageMax || ageMin < ageLimit )
        {
            activityLevel = $('.product_feeding_calculator_section').attr('data-kitten-puppy-activity');
        }
    }
    var x;

    x = ((Math.pow( weight, rerMultiplier ) *  age * activityLevel) / calDensity);
    
    console.log("((" + weight + " ^ "+ rerMultiplier + ") x " + age + " x "+ activityLevel + ")/"+ calDensity);

    return x;
}

function ReallySetBagTime(select)
{
    var selected        = $( select ).prop( "selectedOptions" )[ 0 ];
    var variantData     = JSON.parse( selected.getAttribute( "data-variant-data" ) );
    var variantTitle    = variantData.title.toLowerCase();

    var grams           = $('input[name="grams"]').val();
    var bagWeight       = 0;

    if( variantTitle.includes( "kg" ) )
    {
        bagWeight = variantTitle.replace( "kg", "" );
        bagWeight   = Number( bagWeight )*1000;
        var days    = (bagWeight / grams);
    }
    else if( variantTitle.includes( "g" ) && variantTitle.includes( "x" ) )
    {
        var bagMulti = variantTitle.split(" - ")[0];
        var amtBags = bagMulti.split("x")[0];
        var amtPerBag = bagMulti.split("x")[1].replace("g", "");

        bagWeight = amtBags*amtPerBag;
        // bagWeight   = Number( bagWeight )*1000;
        var days    = (bagWeight / grams);

    }
    else if(variantTitle.includes( "g" ) && !variantTitle.includes( "x" ))
    {
        bagWeight = variantTitle.replace( "g", "" );
        bagWeight   = Number( bagWeight ) * 1000;
        var days    = (bagWeight / grams)/1000;
    }

    $( 'input[name="day"]' ).val( Math.round( days ) );

    var days = Math.round( days );
    var weeks = Math.floor( days / 7 );
    var parentBox = select.closest( '.calculator_box' );
    var frequencySelect = parentBox.querySelector( '.selling_plan_all_groups' );
    var weeksMatched = false;
    for( index in frequencySelect.options )
    {
        if( index > 0 )
        {
            var planWeeks = frequencySelect.options[ index ]?.getAttribute( "data-plan-weeks" );
            if( planWeeks && planWeeks == weeks )
            {
                frequencySelect.selectedIndex = Number(index);
                weeksMatched = true;
            }
            if( index == frequencySelect.options.length-1 && weeksMatched == false )
            {
                var minWeek = Number(frequencySelect.options[ 1 ].getAttribute( "data-plan-weeks" ));
                var maxWeek = Number(frequencySelect.options[ frequencySelect.options.length-1 ].getAttribute( "data-plan-weeks" ));
                if( weeks < minWeek )
                {
                    frequencySelect.selectedIndex = 1;
                }
                else if( weeks > maxWeek )
                {
                    frequencySelect.selectedIndex = frequencySelect.options.length-1;
                }
            }
        }
    }
}

function SetBagTime()
{
    var feedingCalcProductSelector = document.querySelector( ".pet_food_calculation .variant_list select" );
    ReallySetBagTime( feedingCalcProductSelector );
}

function setSellingplan_price() 
{
    var selectElement           = document.querySelector( ".variant_list select" );
    var onetime_priceElement    = document.querySelector( ".onetime_price" );
    var subSave_priceElement    = document.querySelector( ".subSave_price" );
  
    function updatePrices() 
    {
      var selectedOption                = selectElement.options[ selectElement.selectedIndex ];
      onetime_priceElement.innerText    = theme.Currency.formatMoney( selectedOption.getAttribute( "data-originalprice" ) );
      subSave_priceElement.innerText    = theme.Currency.formatMoney( selectedOption.getAttribute( "data-subsave_price" ) );
    }
  
    selectElement.addEventListener( "change", updatePrices );
    updatePrices();
}

function Subscriptionvalidation()
{
    var alloptions      = document.querySelector( '.alloptions' );
    var weekSelectBox   = document.querySelector( '.selling_plan_all_groups' );
    var selected_value  = weekSelectBox.options[ weekSelectBox.selectedIndex ].value;

    if ( selected_value == '' ) 
    {
        weekSelectBox.classList.add("error");
        alloptions.innerHTML += "<p class='error_message'>Please select frequency.</p>";
    };

    setTimeout(() => 
    {
        var error_message   = document.querySelector( '.error_message' );
        if ( error_message ) 
        {           
            document.querySelector( '.selling_plan_all_groups' ).classList.remove("error"); 
            error_message.remove();
        }

    }, 3000);

}


function PFC_ajaxifyAddtocart() 
{
    $( '.product_data .calculator_atc_button' ).on( 'click', function () 
    {
        Subscriptionvalidation();
        var parent = SearchParentsFor( this, "product_data" );
        var variantId = $( parent ).find( '.variant_list select' ).val();

        // Create the data object in the expected format
        if ( $( ".option__subSave.option--active" ).length > 0 ) 
        {
            let selling_select = document.querySelector( '.selling_plan_all_groups' );
            let sellingPlanId = selling_select.options[ selling_select.selectedIndex ].value;
            if ( sellingPlanId != '' ) 
            {                
                data = 
                {
                    id: variantId,
                    selling_plan: sellingPlanId,
                    quantity: 1
                };
            }
        }
        else
        {
            data = 
            {
                id: variantId,
                quantity: 1
            };
        }

        $.ajax({
            url: '/cart/add.js',
            type: 'POST',
            headers: 
            {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify( data ),
            success: function () 
            {

                document.querySelector( ".cart-added-pop-up" ).style.top = "15%";
                document.querySelector( ".cart-added-pop-up" ).style.display = "block";
                setTimeout( function () 
                {
                    document.querySelector( ".cart-added-pop-up" ).style.display = "none";
                    document.querySelector( ".cart-added-pop-up" ).style.top = "25%";

                }, 5000 );
            }
        });
    });
}



document.addEventListener('DOMContentLoaded', () => 
{
    var startCalcButton = document.getElementById("startCalc");

    startCalcButton.addEventListener("click", function()
    {
        calculateAmt();
        SetBagTime();
    } )

    var startMixCalcbutton = document.getElementById("startMixCalc");

    startMixCalcbutton.addEventListener("click", function()
    {
        calculateMix();
    })

    var selectors = document.querySelectorAll(".variant_list select");

    selectors.forEach( function( selector )
    {
        selector.addEventListener("change", function(e)
        {
            ReallySetBagTime( e.currentTarget );
        } );
    })

    var calulator_options =  document.querySelectorAll( 'input[name="active_animal"]' );
    calulator_options.forEach( function( calulator_option )
    {
        listenRadioChange(calulator_option);
    });

    listenSubscriptionButton();
    listenSlideNavigationButton();
    setSellingplan_price();

    // PFC == product feeding calculator Ajax
    PFC_ajaxifyAddtocart();

})